import * as yup from 'yup';

export const autoscalerModeValidationSchema = yup
  .string()
  .oneOf(['IMMEDIATE', 'DEFERRED'])
  .required();
